import script from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=18bbdfa6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18bbdfa6"]])

export default __exports__